class Abilities {
  constructor() {
    this.abilitiesByOrganization = {};
    this.organizationId = null;
  }

  setAbilities({ abilitiesByOrganization, organizationId = null }) {
    if (abilitiesByOrganization) this.abilitiesByOrganization = abilitiesByOrganization;
    this.organizationId = organizationId;
  }

  can(action, subject, organizationId) {
    return this.abilitiesByOrganization[organizationId || this.organizationId].m.some((ability) => ability.action === action && ability.subject === subject);
  }
}

const abilities = new Abilities();

export default abilities;
